export enum EProfitSharingType {
  resale = 'RESALE',
  project = 'PROJECT',
}